import formName from 'constants/formName'
import { ChangeEmailFormType, StateType } from 'data/types'
import { getFormValues } from 'redux-form'
import { createSelector } from 'reselect'

// FIXME "as ChangeEmailFormType" should  not be needed as type should be infered, find out what's missing
const getValues = (state: StateType): ChangeEmailFormType =>
  getFormValues(formName.CHANGE_EMAIL)(state) as ChangeEmailFormType

const getNewEmail: (state: StateType) => string = createSelector(
  getValues,
  ({ newEmail }) => newEmail
)

const getOldEmail: (state: StateType) => string = createSelector(
  getValues,
  ({ oldEmail }) => oldEmail
)

const isLoading: (state: StateType) => boolean = createSelector(getValues, ({ loading }) => loading)

export default {
  getNewEmail,
  getOldEmail,
  getValues,
  isLoading
}
